import React, { Fragment } from 'react';

import styled from 'styled-components';
import Styles from './ModalToSelectSeats.Styles';
import Text from '../../base/Text';
import ValidateButton from '../../compound/TicketsWhite/ValidateButton';
import car_seat_icon_gray from '../../../assets/images/Shuttle/car_seat_icon_gray.png';
import car_seat_icon_pink from '../../../assets/images/Shuttle/car_seat_icon_pink.png';
import car_seat_icon_purple from '../../../assets/images/Shuttle/car_seat_icon_purple.png';

const Header = styled.div`${Styles.header}`; // prettier-ignore
const Body = styled.div`${Styles.body}`; // prettier-ignore
const Title = styled.h3`${Styles.title}`; // prettier-ignore
const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const TypeColor = styled.div`${Styles.typeColor}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;


const ModalToSelectSeats = ({
  onSelectedSeat,
  onUnSelectSeat,
  blockedSeats,
  selectedSeat,
  openModalSelectedSeats,
  translations,
  goToPersonalInfo,
  shuttlePassengers,
  selectedCounter,
  page,
  from,
  to,
  shuttleDetails
}) => {

  const select = (id, rowData) => {
    const seats = [...selectedSeat];
    const found = seats.find(element => element.id === id);
    console.log(found);
    if (!found) {
      if (seats.length < shuttlePassengers) {
        seats.push(id);
        onSelectedSeat(id, rowData);
      }
      return ;
    }
    if (found.id === id) {
      console.log("Removing");
      seats.splice(seats.indexOf(id), 1);
      onUnSelectSeat(id, rowData);
    }
  };

  const Seat = ({ id, number, numberSeat, isAvailable: seatAvailable }) => {
    if (!id) id = number;
    const found = selectedSeat.filter(element => element.id === id).length > 0;
    const isAvailable = seatAvailable && !blockedSeats.includes(id);
    return (
      <div
        style={{cursor: 'pointer', position:"relative", width:'3rem', height:'3rem', margin: '8px'}}
        onClick={() => isAvailable && select(id, number)}
      >
        <img
          alt="Seat"
          src={!isAvailable ? car_seat_icon_pink : found ? car_seat_icon_purple : car_seat_icon_gray}
          id={id}
          style={{
            height:'100%', position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)'
          }}
        />
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            margin: '0',
            lineHeight: '1em',
            transform: 'translateX(-50%)',
            textAlign: 'center',
            color: 'white'
          }}
        >
          {numberSeat}
        </span>
      </div>
    );
  };

  const SeatRow = ({ row, columnData }) => {
    const seats = Object.keys(columnData);
    return seats.map((index) => {
      const {
        seatId,
        seatNumber: numberSeat,
        isAvailable
      } = columnData[index];
      return (
        <Column>
          <Seat row={row} id={seatId} number={`${row.replace('_','-')}-${numberSeat}`} numberSeat={numberSeat} isAvailable={isAvailable} />
        </Column>
      );
    });
  };

  let letters = Object.keys(shuttleDetails.data.passengersS);
  let { totalSeats } = shuttleDetails.data;
  if (!letters) letters = [];
  if (!totalSeats) totalSeats = 1;
  const seats = letters.map((letter) => {
    const columnData = shuttleDetails.data.passengersS[letter];
    return (
      <Row>
        <SeatRow row={letter} columnData={columnData} />
      </Row>
    );
  });
  return (
    <Fragment style={{ flex: 1 }} onClick={openModalSelectedSeats}>
      <Header border>
        <Title className="cbx-bold" />
      </Header>
      <Body>
        <p style={{
          marginLeft: '80px',
          color: 'rgb(239, 96, 163)',
          fontWeight: 'bolder',
          fontSize: 18,
          marginBottom: 0
        }}
        >
          {translations.selectYourSeat}

          {from && to && ` ${from} -> ${to}`}
        </p>
        <p style={{
          marginLeft: '80px',
          color: '#D8D8D8',
          fontWeight: 'bolder',
          fontSize: 14
        }}
        >
          {translations.avalaibleSeat} {totalSeats - selectedSeat.length}
        </p>
        <Row style={{ justifyContent: 'center' }}>
          <Column>
            <Column style={{ marginTop: '20px' }}>{seats}</Column>
          </Column>
          <Column style={{
            alignSelf: 'flex-start',
            margin: '15% 5% 14% 15%'
          }}
          >
            <Row>
              <TypeColor color="gray" />
              <Text style={{ color: '#3F2A55', fontSize: 15, }}>{translations.available}</Text>
            </Row>
            <Row>
              <TypeColor color="rgb(239, 96, 163)" />
              <Text style={{ color: '#3F2A55', fontSize: 15, }}>{translations.occupied}</Text>
            </Row>
            <Row>
              <TypeColor color="#3F2A55" />
              <Text style={{ color: '#3F2A55', fontSize: 15, }}>{translations.selectSeat}</Text>
            </Row>
            <Row>
              <Text style={{
                color: '#3F2A55',
                fontWeight: 600,
                fontSize: 20,
                textAlign: 'end',
                marginTop: '20px',
                fontFamily: 'Open Sans ,sans-serif'
              }}
              >
                {translations.seat}{shuttlePassengers < 2 ? '' : 's'}:
              </Text>
              <Text style={{
                color: '#3F2A55',
                fontWeight: 600,
                fontSize: 20,
                textAlign: 'end',
                marginTop: '20px',
                fontFamily: 'Open Sans ,sans-serif',
                height: 'auto'
              }}
              >
                {selectedSeat.map(seat => (seat.number)).toString()}
              </Text>
            </Row>
          </Column>
        </Row>
        <ButtonContainer>
          <ValidateButton
            disabled={shuttlePassengers > selectedSeat.length}
            action={goToPersonalInfo}
            message={translations.continueLabel}
          />
        </ButtonContainer>
      </Body>
    </Fragment>
  );
};

export default ModalToSelectSeats;
